import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/lb-api';

const ChatHistory = ({ user }) => {
  const [conversations, setConversations] = useState([]);
  const [selectedConv, setSelectedConv] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterPage, setFilterPage] = useState('all');

  const pageLabels = {
    'learn': 'Learn',
    'practice-reading': 'Reading',
    'practice-listening': 'Listening',
    'practice-writing': 'Writing',
    'practice-speaking': 'Speaking'
  };

  useEffect(() => {
    if (!user?.email) return;
    console.log('Loading conversations for:', user.email);
    axios.get(`${API_BASE_URL}/chat/conversations?enterprise_id=${encodeURIComponent(user.email)}`, { withCredentials: true })
      .then(res => { 
        console.log('Conversations loaded:', res.data.conversations?.length, res.data.conversations?.map(c => c.page_name));
        setConversations(res.data.conversations || []); 
        setLoading(false); 
      })
      .catch((err) => { console.error('Failed to load conversations:', err); setLoading(false); });
  }, [user]);

  const loadMessages = async (convId) => {
    setSelectedConv(convId);
    setMessages([]); // Clear previous messages immediately
    try {
      const res = await axios.get(`${API_BASE_URL}/chat/conversation/${convId}/messages`, { withCredentials: true });
      console.log('Messages for conv', convId, ':', res.data);
      setMessages(res.data.messages || []);
    } catch (err) {
      console.error('Failed to load messages:', err);
      setMessages([]);
    }
  };

  if (loading) return <div style={{ padding: 40 }}>Loading...</div>;

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Header user={user} />
      <div style={{ display: 'flex', flex: 1, padding: 20, gap: 20, overflow: 'hidden' }}>
        <div style={{ width: 300, borderRight: '1px solid #eee', paddingRight: 20, overflowY: 'auto' }}>
          <h3 style={{ marginBottom: 12 }}>Conversations</h3>
          <div style={{ marginBottom: 12 }}>
            <select
              value={filterPage}
              onChange={(e) => setFilterPage(e.target.value)}
              style={{ width: '100%', padding: '6px 8px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}
            >
              <option value="all">All Pages</option>
              {Object.entries(pageLabels).map(([key, label]) => (
                <option key={key} value={key}>{label}</option>
              ))}
            </select>
          </div>
          {conversations.filter(c => filterPage === 'all' || c.page_name === filterPage).length === 0 && <p style={{ color: '#999' }}>No conversations yet</p>}
          {conversations.filter(c => filterPage === 'all' || c.page_name === filterPage).map(c => (
            <div
              key={c.id}
              onClick={() => loadMessages(c.id)}
              style={{
                padding: '10px 12px', marginBottom: 8, borderRadius: 8, cursor: 'pointer',
                background: selectedConv === c.id ? '#F3E8FF' : '#f9f9f9',
                border: selectedConv === c.id ? '1px solid #A100FF' : '1px solid #eee'
              }}
            >
              <div style={{ fontWeight: 600, fontSize: 14 }}>{c.title || 'Untitled'}</div>
              <div style={{ fontSize: 12, color: '#888' }}>
                {pageLabels[c.page_name] || c.page_name} · {c.language} {c.level} · {new Date(c.created_at).toLocaleDateString()}
              </div>
            </div>
          ))}
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <h3 style={{ marginBottom: 16 }}>Messages {selectedConv ? `(${messages.length})` : ''}</h3>
          {!selectedConv && <p style={{ color: '#999' }}>Select a conversation</p>}
          {selectedConv && messages.length === 0 && <p style={{ color: '#999' }}>No messages found</p>}
          {messages.map((m, idx) => (
            <div key={m.id} style={{ marginBottom: 16 }}>
              {m.user_input && (
                <div style={{ textAlign: 'right', marginBottom: 6 }}>
                  <span style={{ background: '#A100FF', color: '#fff', padding: '8px 14px', borderRadius: 16, display: 'inline-block', maxWidth: '70%', whiteSpace: 'pre-wrap', textAlign: 'left' }}>
                    {m.user_input}
                  </span>
                </div>
              )}
              {m.prompt && !m.user_input && (
                <div style={{ textAlign: 'right', marginBottom: 6 }}>
                  <span style={{ background: '#E8E8E8', padding: '8px 14px', borderRadius: 16, display: 'inline-block', fontSize: 13 }}>
                    Prompt: {m.prompt}
                  </span>
                </div>
              )}
              {m.agent_response && (
                <div style={{ marginBottom: 6 }}>
                  <span style={{ background: '#f5f5f5', padding: '10px 14px', borderRadius: 16, display: 'inline-block', maxWidth: '80%', whiteSpace: 'pre-wrap' }}>
                    {m.agent_response}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ChatHistory;
